import Vue from 'vue'
import getParams from '../utils/getParams'
import cnLang from './cnLang'
import enLang from './enLang'

let {platformType, platformUserType} = getParams()
platformType = Number(platformType) || 0
platformUserType = Number(platformUserType) || 3

// 汉语吧or说客的老师 展示英文
let isShowEnglish = Boolean(platformType === 2 || (platformType === 0 && platformUserType === 2))

let themeConfig = {
  // 说客平台
  0: {
    platformName: isShowEnglish ? 'Talk915' : '说客英语',
    kfImgUrl: '/im/static/img/kf_avatar.png',
    globalCssVariable: {
      '--main-color': '#0087ff'
    }
  },
  // 青豆
  1: {
    platformName: '青豆网校',
    kfImgUrl: '/im/static/img/kf_avatar2.png',
    globalCssVariable: {
      '--main-color': '#21c74f'
    }
  },
  // 汉语吧
  2: {
    platformName: 'HanyuBar',
    kfImgUrl: '/im/static/img/chinese.png',
    globalCssVariable: {
      '--main-color': '#ff3c41'
    }
  }
}

let theme = themeConfig[platformType] || themeConfig[0]

// 设置全局样式变量
for (const key in theme.globalCssVariable) {
  document.documentElement.style.setProperty(key, theme.globalCssVariable[key])
}

Vue.prototype.$isShowEnglish = isShowEnglish
Vue.prototype.$theme = theme
Vue.prototype.$lang = isShowEnglish ? enLang : cnLang



// WEBPACK FOOTER //
// ./src/theme/index.js